module.exports = __webpack_public_path__ + "static/media/Roboto-Regular.8a36205b.ttf";